import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaConsultaCodigoCupoParaActorActions'
import { TablaConsultaCodigoCupoParaActorView } from '../components/TablaConsultaCodigoCupoParaActorView'

class TablaConsultaCodigoCupoParaActor extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaConsultaCodigoCupoParaActorView />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaConsultaCodigoCupoParaActor)
